<template>
  <div>
    <PageAllow controller="ThirdAccountInfo" action="indexForLkl" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet v-show="!currentItemMode" class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="keyword = $event"
                :label="
                  $t('LakalaAccount.Keyword')
                "
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('ThirdAccountInfo', 'addLklUser')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("LakalaAccount.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 高级搜索条件 -->
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="lakalaAccount"
            :loading="loading"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-2 px-4 pt-1 sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            id="sticky-table"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.created="{ item }">
              <span>
                 {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.actions.open="{ item }">
              <v-chip
                small
                label
                :color="item.lakala_member_no ? 0 : 1 | huifuStatusColor"
                :text-color="item.lakala_member_no ? 0 : 1 | huifuStatusTextColor"
              >
                {{ item.lakala_member_no ? 0 : 1 | huifuStatusText }}
              </v-chip>
            </template>
            <template v-slot:item.actionsBtn="{ item }">
              <v-btn
                v-if="$permission.permissionAllow('ThirdAccountInfo', 'view')"
                small
                dark
                color="info"
                class="px-2 me-2 mb-1"
                @click.stop="
                  currentItemMode = 'view';
                  currentItem = item;
                "
              >
                {{ $t("LakalaAccount.actionBtn.detail") }}
              </v-btn>
              <v-btn
                v-if="item.actions.lkl_edit_user"
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="
                  currentItemMode = 'edit';
                  currentItem = item;
                "
              >
                {{ $t("LakalaAccount.actionBtn.edit") }}
              </v-btn>
              <v-btn
                v-if="item.actions.lkl_create_user"
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="$router.push('/lakala/create-user/' + item.id)"

              >
                {{ $t("LakalaAccount.actionBtn.createUser") }}
              </v-btn>
              <v-btn
                v-if="item.actions.lkl_card"
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="bindCard(item)"

              >
                {{ $t("LakalaAccount.actionBtn.bindCard") }}
              </v-btn>
              <v-btn
                v-if="item.lakala_member_no"
                small
                dark
                color="action"
                class="px-2 me-2 mb-1"
                @click.stop="
                  payDialog = true;
                  payItem = item;
                "
              >
                {{ $t("LakalaAccount.actionBtn.pay") }}
              </v-btn>
              <v-btn
                v-if="item.actions.lkl_cash"
                small
                dark
                color="action"
                class="px-2 me-2 mb-1"
                @click.stop="
                  cashDialog = true;
                  cashItem = item;
                "
              >
                {{ $t("LakalaAccount.actionBtn.cash") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <ThirdAccountDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getLakalaAccountFromAPI()"
    />

    <!-- 余额支付 -->
    <PayDialog
      v-model="payDialog"
      :item="payItem"
    />

    <!-- 余额支付 -->
    <CashDialog
      v-model="cashDialog"
      :cashItem="cashItem"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import ThirdAccountInfo from "@/api/third-account-info"
import ThirdAccountDetail from "./plugins/Detail";
import LakalaInterface from "@/api/lakala_interface"
import PayDialog from "./plugins/PayDialog";
import CashDialog from "./plugins/CashDialog";

const defaultOptions = {
  keyword: "",
  pay_type: 104
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    ThirdAccountDetail,
    PayDialog,
    CashDialog,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.thirdPayment"),
          disabled: false,
          href: "/lakala",
        },
        {
          text: i18n.t("Nav.lakalaAccount"),
          disabled: true,
          href: "/lakala",
        },
      ];
    },

    headers() {
      return [
        {
          text: i18n.t("LakalaAccount.Fields.company_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "company_name",
        },
        {
          text: i18n.t("LakalaAccount.Fields.out_member_no"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "lakala_out_member_no",
        },
        {
          text: i18n.t("LakalaAccount.Fields.lakala_member_no"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "lakala_member_no",
        },
        {
          text: i18n.t("LakalaAccount.Fields.created"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "created",
        },
        {
          text: i18n.t("LakalaAccount.Fields.status"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "actions.open",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actionsBtn",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {},

  data: () => ({
    lakalaAccount: [],
    keyword: "",
    options: JSON.parse(
      sessionStorage.getItem("lakala-options")
        ? sessionStorage.getItem("lakala-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    payDialog: false,
    cashDialog: false,
    payItem: {},
    cashItem: {},
  }),

  methods: {
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
      });
    },
    getLakalaAccountFromAPI() {
      ThirdAccountInfo.indexForLkl(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lakalaAccount = response.data.third_account;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    bindCard(data) {
      if (data.lakala_member_no) {
        this.$store.dispatch("fullscreenLoading");
        LakalaInterface.bandCard({member_no: data.lakala_member_no}).then(
          function (response) {
            if (response.data.status.isOK()) {
              window.open(response.data.result.url, '_blank');
              this.$router.replace("/lakala");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        ).catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace("/lakala?id=" + this.currentItem.id);
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.getLakalaAccountFromAPI()
          this.$router.replace("/lakala");
        }
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getLakalaAccountFromAPI();
        sessionStorage.setItem(
          "lakala-options",
          JSON.stringify(this.options)
        );
      },
    },
    payDialog: {
      deep:true,
      handler() {
        if (!this.payDialog) {
          this.payItem = {};
        }
      }
    },
    cashDialog: {
      deep:true,
      handler() {
        if (!this.cashDialog) {
          this.cashItem = {};
        }
      }
    },
  },
};
</script>